// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"39c5badc","496":"8d8889c6","647":"be7d10f2"}[chunkId] + ".chunk.js";
};